export default function UnexpectedClientError() {
    return (
        <div>
            <h2>Internal Error</h2>
            <p>Please contact support for help</p>
        </div>
    );
}
